"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const productCardContainerInputs = [
  {
    name: "title",
    type: "string",
  },
  {
    name: "ctaLabel",
    friendlyName: "Button label",
    type: "string",
  },
  {
    name: "ctaHref",
    friendlyName: "Button link",
    type: "url",
  },
  {
    name: "isCarousel",
    friendlyName: "Should use carousel representation",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "desktopItemCount",
    showIf: `options.get("isCarousel") === "true"`,
    friendlyName: "Number of items to show in desktop view",
    helperText: "Only numbers from 1-4 must be chosen",
    type: "number",
    min: 1,
    max: 4,
    defaultValue: 3,
  },
  {
    name: "tabletItemCount",
    showIf: `options.get("isCarousel") === "true"`,
    friendlyName: "Number of items to show in tablet view",
    helperText: "Only numbers from 1-3 must be chosen",
    type: "number",
    min: 1,
    max: 3,
    defaultValue: 2,
  },
  {
    name: "isOverflowEnabled",
    showIf: `options.get("isCarousel") === "true"`,
    friendlyName: "Show overflow of carousel items",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isControlHidden",
    showIf: `options.get("isCarousel") === "true"`,
    friendlyName: "Should hide controls",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const ProductCardContainerComponent: RegisteredComponent = {
  name: "ProductCardContainer",
  component: dynamic(
    async () => (await import("./ProductCardContainer")).ProductCardContainer
  ),
  inputs: productCardContainerInputs,
  canHaveChildren: true,
};
